// import React, { lazy, Suspense } from "react";
// import { useParams } from "react-router-dom";

// const productComponents = {
//   "Quality Intelligence": lazy(() => import("./Product1")),
//   "Engineering Acceleration": lazy(() => import("./Product2")),
//   "Fleet Optimization": lazy(() => import("./Product3")),
//   "Data Monetization": lazy(() => import("./Product4")),
//   "Customer Experience": lazy(() => import("./Product5")),
//   "Compliance & Sustainability": lazy(() => import("./Product6")),
// };

// const DynamicProduct = () => {
//   const { productName } = useParams();
//   const DecodedName = decodeURIComponent(productName);

//   const Component = productComponents[DecodedName];

//   return (
//     <div>
//       <Suspense fallback={<div>Loading...</div>}>
//         {Component ? <Component /> : <div>Product not found</div>}
//       </Suspense>
//     </div>
//   );
// };

// export default DynamicProduct;



// ✅ Updated: DynamicProduct.jsx
import React, { lazy, Suspense, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Preloader from "../Miscellaneous/Preloader";

const productComponents = {
  "quality-intelligence": lazy(() => import("./Product1")),
  "engineering-acceleration": lazy(() => import("./Product2")),
  "fleet-optimization": lazy(() => import("./Product3")),
  "data-monetization": lazy(() => import("./Product4")),
  "customer-experience": lazy(() => import("./Product5")),
  "compliance-and-sustainability": lazy(() => import("./Product6")),
};

const DynamicProduct = () => {
  const { productName } = useParams();
  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }, [location.pathname]);


  const Component = productComponents[productName.toLowerCase()];

  return (
    <Suspense fallback={<Preloader />}>
      {Component ? <Component /> : <div>Product not found</div>}
    </Suspense>
  );
};

export default DynamicProduct;
